import DeletePopOver from 'Components/DeletePopOver';
import ErrorComponent from 'Components/ErrorComponent';
import ErrorTooltip from 'Components/ErrorTooltip';
import { errorToast, successToast } from 'Components/Toasts';
import env from 'environment_system/env_system';
import { FormikProps, useFormik } from 'formik';
import { checkValidArray, errResponse } from 'GenericForms/Helper';
import apiGlobal from 'global/api.global';
import { RootState } from 'index';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { queryClient } from 'react-query/queryClient';
import { useSelector } from 'react-redux';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { VesselConfigrationTabs, VesselDataConstants } from 'shared/constants';
import { queryKeyes } from 'shared/queryKeys';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import * as Yup from "yup";
import isEqual from "fast-deep-equal";
import { commonValidationMessages } from 'Components/ValidationErrorMessages';
import FormLoading from 'Components/FormLoading';
import Select from "react-select";
interface EmailReportingType {
    activeTab: number | string,
    VesselConfActiveTab: number
    setCheckVesselDataValuesBeforeSwitch?: (value: boolean) => void;
    setVesselDataTabName?: (value: string) => void;
    setCheckValuesBeforeSwitch?: (value: boolean) => void;
    setTabName?: (value: string) => void;
    setFormik?: (value: FormikProps<any>) => void;
    formik?: FormikProps<any>;
    setTabFormik?: (value: FormikProps<any>) => void;
    setDisableYesButtonInsideTab?: (value: boolean) => void;
    saveBeforeChangePopUpInsideTab?: boolean;
    saveBeforeChangePopUp?: boolean;
    refreshKey?: number;
    setRefreshKey?: any;
}

const EmailReporting = ({
    activeTab,
    VesselConfActiveTab,
    setCheckVesselDataValuesBeforeSwitch,
    setVesselDataTabName,
    setCheckValuesBeforeSwitch,
    setTabName,
    setTabFormik,
    setDisableYesButtonInsideTab,
    saveBeforeChangePopUpInsideTab,
    saveBeforeChangePopUp,
    refreshKey,
    setRefreshKey,
}: EmailReportingType) => {
    /** State variables */
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    const [popOverBool, setPopOverBool] = useState<boolean | null>(false);
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null);

    /** Queries */
    const { data: emailReportingObject, isLoading: emailReportingObjectLoading, isError: emailReportingObjectError } = useQuery(
        [queryKeyes.vessel.VesselReportingEmail.key, VesselID],
        async () => {
            return await Get(queryKeyes.vessel.VesselReportingEmail.url(VesselID), VesselID);
        },
        { staleTime: Infinity }
    );
    const { data: emailCategoryObject } = useQuery(
        [queryKeyes.vessel.EmailCategory.key],
        async () => {
            return await Get(queryKeyes.vessel.EmailCategory.url);
        },
        { staleTime: Infinity }
    );
    /** Assign initial values */
    const getInitialValues = () => {
        if (checkValidArray(emailReportingObject) && emailReportingObject.length > 0) {
            return emailReportingObject;
        } else {
            return [
                {
                    name: null as string,
                    email: null as string,
                    vessel: VesselID as number,
                    email_type: [] as string[]
                }
            ];
        }
    };

    const handleDelete = (index: number) => {
        const emailToDelete = emailReportingFormik.values[index];
        const updatedEmails = emailReportingFormik.values.filter((_: any, i: any) => i !== index);

        if (emailToDelete.id) {
            // If the object has an ID, send a DELETE request
            apiGlobal
                .delete(`/${queryKeyes.vessel.VesselReportingEmail.url()}${emailToDelete.id}/`)
                .then(() => {
                    successToast("Email deleted successfully!");
                    queryClient.invalidateQueries(queryKeyes.vessel.VesselReportingEmail.key);
                    // Update the emails list after successful deletion
                    emailReportingFormik.setValues(updatedEmails);
                })
                .catch((err) => {
                    if (errResponse.includes(err?.response?.status)) {
                        errorToast("Failed to delete email, please contact the admin");
                    }
                });
        } else {
            // If no ID, simply remove it from the Formik state
            emailReportingFormik.setValues(updatedEmails);
        }
    };

    const emailReportingFormik: any = useFormik({
        enableReinitialize: true,
        initialValues: getInitialValues(),
        validationSchema: Yup.array().of(
            Yup.object({
                name: Yup.string()
                    .required(commonValidationMessages.required)
                    .min(2, commonValidationMessages.min2)
                    .max(25, commonValidationMessages.max25Char)
                    .matches(/^[A-Za-z\s]+$/, commonValidationMessages.onlycharacters),
                email: Yup.string()
                    .email("Invalid email address")
                    .required("Email address is required"),
                email_type: Yup.array()
                    .of(Yup.string())
                    .min(1, commonValidationMessages.required)
                    .required(commonValidationMessages.required),
            })
        ),
        onSubmit: async (values: any, actions: any) => {
            try {
                actions.setSubmitting(true);
                try {
                    const response = await apiGlobal.post(
                        `/${queryKeyes.vessel.VesselReportingEmail.url()}`,
                        values
                    );
                    if (response.status === 200 || response.status === 201) {
                        successToast("Emails sent successfully!");
                        queryClient.invalidateQueries(queryKeyes.vessel.VesselReportingEmail.key);
                        queryClient.invalidateQueries(queryKeyes.vessel.ConfigurationList.key);
                    } else {
                        errorToast(response.data?.message || "Failed to send emails, please try again.");
                    }
                } catch (error: any) {
                    errorToast(
                        error?.response?.data?.error ||
                        "An unexpected error occurred while sending emails."
                    );
                }
            } catch (err) {
                console.error("Email reporting submission failed:", err);
            } finally {
                actions.setSubmitting(false);
            }
        },
    });
    const tabName = 'Email Reporting';
    const handleFormikStateChange = (values: any, initialValues: any) => {
        const areValuesEqual = isEqual(values, initialValues);;
        setCheckValuesBeforeSwitch(areValuesEqual);
        setTabName(tabName);
        setCheckVesselDataValuesBeforeSwitch(areValuesEqual);
        setVesselDataTabName(tabName);
        return areValuesEqual;
    };

    /**Start of UseEffect*/
    useEffect(() => {
        if (activeTab === VesselDataConstants.EMAIL_REPORTING && emailReportingFormik.values !== emailReportingFormik.initialValues) {
            Object.keys(emailReportingFormik?.errors).length > 0 ? setDisableYesButtonInsideTab(true) : setDisableYesButtonInsideTab(false);
            setTabFormik(emailReportingFormik);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, setTabFormik, emailReportingFormik, emailReportingFormik?.errors]);
    useEffect(() => {
        if (setCheckValuesBeforeSwitch) {
            handleFormikStateChange(emailReportingFormik?.values, emailReportingFormik?.initialValues);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailReportingFormik?.values, emailReportingFormik?.initialValues]);
    useEffect(() => {
        emailReportingFormik.initialValues = getInitialValues();
        emailReportingFormik.values = getInitialValues();
        setRefreshKey(refreshKey + 1);
        queryClient.invalidateQueries(queryKeyes.vessel.VesselReportingEmail.key);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailReportingObject, VesselID]);
    useEffect(() => {
        if (activeTab !== "3" && VesselConfActiveTab === VesselConfigrationTabs.VESSEL_DATA) {
            emailReportingFormik?.setTouched({})
            emailReportingFormik?.setErrors({})
        }
        if (VesselConfActiveTab !== VesselConfigrationTabs.VESSEL_DATA) {
            emailReportingFormik?.setTouched({})
            emailReportingFormik?.setErrors({})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, VesselConfActiveTab]);

    /** Add email entry */
    const addEmailEntry = () => {
        emailReportingFormik.setValues([
            ...emailReportingFormik.values,
            { name: "", email: "", vessel: VesselID as number || null, email_type: [] },
        ]);
    };

    return (
        <React.Fragment>
            {emailReportingObjectLoading && <FormLoading />}
            {emailReportingObjectError && <ErrorComponent message="Unable to load required data!" />}
            {!emailReportingObjectLoading && (
                <div>
                    <form autoComplete="off" onSubmit={emailReportingFormik.handleSubmit} key={refreshKey}>
                        {emailReportingFormik.values.map((email: any, index: number) => (
                            <Row className="mb-3" key={index}>
                                <Col lg={3}>
                                    <Label className="mb-1 asteric" for={`email_name_${index}`}>
                                        Name
                                    </Label>
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        autoComplete="off"
                                        name={`${index}.name`}
                                        id={`email_name_${index}`}
                                        value={email.name}
                                        onChange={(e) => {
                                            emailReportingFormik.setFieldValue(`${index}.name`, e.target.value);
                                            emailReportingFormik.setFieldTouched(`${index}.name`, true, false);
                                        }}
                                        className="form-control"
                                    />
                                    {emailReportingFormik?.touched?.[index]?.name &&
                                        emailReportingFormik?.errors?.[index]?.name &&
                                        env?.form_validation === true ? (
                                        <ErrorTooltip
                                            target={`email_name_${index}`}
                                            message={emailReportingFormik.errors?.[index]?.name}
                                            open={
                                                !saveBeforeChangePopUpInsideTab &&
                                                !saveBeforeChangePopUp &&
                                                activeTab === VesselDataConstants.EMAIL_REPORTING &&
                                                !!emailReportingFormik?.errors?.[index]?.name
                                            }
                                        />
                                    ) : null}
                                </Col>
                                <Col lg={3}>
                                    <Label className="mb-1 asteric" for={`email_email_${index}`}>
                                        Email
                                    </Label>
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        autoComplete="off"
                                        name={`${index}.email`}
                                        id={`email_email_${index}`}
                                        value={email.email}
                                        onChange={(e) => {
                                            emailReportingFormik.setFieldValue(`${index}.email`, e.target.value);
                                            emailReportingFormik.setFieldTouched(`${index}.email`, true, false);
                                        }}
                                        className="form-control"
                                    />
                                    {emailReportingFormik?.touched?.[index]?.email &&
                                        emailReportingFormik?.errors?.[index]?.email &&
                                        env?.form_validation === true ? (
                                        <ErrorTooltip
                                            target={`email_email_${index}`}
                                            message={emailReportingFormik.errors?.[index]?.email}
                                            open={
                                                !saveBeforeChangePopUpInsideTab &&
                                                !saveBeforeChangePopUp &&
                                                activeTab === VesselDataConstants.EMAIL_REPORTING &&
                                                !!emailReportingFormik?.errors?.[index]?.email
                                            }
                                        />
                                    ) : null}
                                </Col>
                                <Col lg={3}>
                                    <Label className="mb-1 asteric" for={`email_type_${index}`}>
                                        Type
                                    </Label>
                                    <Select
                                        inputId={`email_type_${index}`}
                                        name={`${index}.email_type`}
                                        options={
                                            emailCategoryObject?.map((obj: any) => ({
                                                value: obj.id,
                                                label: obj.email_type,
                                            })) || []
                                        }
                                        isMulti
                                        placeholder="Select type"
                                        value={
                                            checkValidArray(emailReportingFormik.values[index].email_type)
                                                ? emailCategoryObject
                                                    ?.filter((opt: any) =>
                                                        emailReportingFormik.values[index].email_type.includes(opt.id)
                                                    )
                                                    ?.map((opt: any) => ({
                                                        value: opt.id,
                                                        label: opt.email_type,
                                                    }))
                                                : []
                                        }
                                        onChange={(selectedOptions: any) => {
                                            const selectedIds = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
                                            emailReportingFormik.setFieldValue(`${index}.email_type`, selectedIds);
                                            emailReportingFormik.setFieldTouched(`${index}.email_type`, true, false);
                                        }}
                                        onBlur={() => {
                                            emailReportingFormik.setFieldTouched(`${index}.email_type`, true, false);
                                        }}
                                    />
                                    {emailReportingFormik?.touched?.[index]?.email_type &&
                                        emailReportingFormik?.errors?.[index]?.email_type &&
                                        env?.form_validation === true ? (
                                        <ErrorTooltip
                                            target={`email_type_${index}`}
                                            message={emailReportingFormik.errors?.[index]?.email_type}
                                            open={
                                                !saveBeforeChangePopUpInsideTab &&
                                                !saveBeforeChangePopUp &&
                                                activeTab === VesselDataConstants.EMAIL_REPORTING &&
                                                !!emailReportingFormik?.touched?.[index]?.email_type &&
                                                !!emailReportingFormik?.errors?.[index]?.email_type
                                            }
                                        />
                                    ) : null}
                                </Col>
                                <Col lg={3} className="d-flex align-items-center">
                                    {emailReportingFormik.values.length > 1 && (
                                        <button
                                            type="button"
                                            className="btn mt-4"
                                            name={`email_delete_${index}`}
                                        >
                                            <i
                                                id={`email_delete_${index}`}
                                                className="dripicons-trash icon_s18 cursor-pointer"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setDeleteIndex(index);
                                                    setPopOverBool(true);
                                                }}
                                            />
                                        </button>
                                    )}
                                    {index === emailReportingFormik.values.length - 1 &&
                                        emailReportingFormik.values.length <= 9 && (
                                            <Button
                                                color="primary"
                                                type="button"
                                                className="ms-2 mt-3"
                                                onClick={addEmailEntry}
                                            >
                                                <i className="dripicons-plus icon_s18 navbar_menu" />
                                            </Button>
                                        )}
                                </Col>
                            </Row>
                        ))}
                        {popOverBool && deleteIndex !== null && (
                            <DeletePopOver
                                target={`email_delete_${deleteIndex}`}
                                state={popOverBool}
                                setState={setPopOverBool}
                                onClick={async () => {
                                    await handleDelete(deleteIndex);
                                    setPopOverBool(false);
                                }}
                            />
                        )}
                        <Row>
                            <div className="d-flex flex-wrap gap-5 grp_justify_right">
                                <Button
                                    type="submit"
                                    color="primary"
                                    disabled={emailReportingFormik.isSubmitting}
                                    className="btn_size4_5_cstm"
                                >
                                    {emailReportingFormik.isSubmitting ? (
                                        <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                                    ) : (
                                        "Save"
                                    )}
                                </Button>
                                <Button
                                    type="reset"
                                    color="danger"
                                    className="btn_size4_5_cst"
                                    onClick={() => emailReportingFormik.resetForm()}
                                >
                                    Reset
                                </Button>
                            </div>
                        </Row>
                    </form>

                    <FormValuesDebug
                        values={[
                            emailReportingFormik.values,
                            emailReportingFormik.errors,
                            emailReportingFormik.initialValues,
                            emailReportingFormik.touched,
                        ]}
                    />
                </div>
            )}
        </React.Fragment>
    );
};

export default EmailReporting;